import { Component } from '../core/smpl-components'

// -----------------------------------------------------------------------------
// Book tilt — the cover on a product card turns to face the mouse.
//
// The book itself is CSS (the 3D `.product-card__book` in _product-list.scss, with
// an edge face on every side). This only maps the pointer over the card to
// `--tilt-x` / `--tilt-y` on the book; the CSS transition smooths the motion
// and eases it back when the pointer leaves. Mouse only: a tap would leave the
// book stuck mid-tilt. Skipped entirely with reduced motion.
// Selector: `.js-book-tilt` (see setup/components.js).
// -----------------------------------------------------------------------------
const MAX_TURN = 30 // deg, left / right
const MAX_TILT = 20 // deg, up / down

export default class extends Component {
	mount() {
		this.elBook = this.element.querySelector('.product-card__book')

		if (!this.elBook || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

		this.onPointerMove = (ev) => {
			if (ev.pointerType !== 'mouse') return

			const rect = this.element.getBoundingClientRect()
			// -1 … 1 across the card, 0 in the middle.
			const x = ((ev.clientX - rect.left) / rect.width) * 2 - 1
			const y = ((ev.clientY - rect.top) / rect.height) * 2 - 1

			// Positive rotateY faces right, positive rotateX faces up: the cover
			// looks at the mouse, showing the edge on the far side.
			this.elBook.style.setProperty('--tilt-y', `${(x * MAX_TURN).toFixed(2)}deg`)
			this.elBook.style.setProperty('--tilt-x', `${(-y * MAX_TILT).toFixed(2)}deg`)
		}

		this.onPointerLeave = () => {
			this.elBook.style.removeProperty('--tilt-x')
			this.elBook.style.removeProperty('--tilt-y')
		}

		this.element.addEventListener('pointermove', this.onPointerMove)
		this.element.addEventListener('pointerleave', this.onPointerLeave)
	}

	unmount() {
		if (!this.onPointerMove) return

		this.element.removeEventListener('pointermove', this.onPointerMove)
		this.element.removeEventListener('pointerleave', this.onPointerLeave)
	}
}
